module.exports = __webpack_public_path__ + "B_left_click.3c9b93c4.png";